import * as TemplateTypes from 'types/template.types'
import BaseScene from './base';
import EventHorizonBackgroundFX from 'fx/background/event-horizon';
import PointerWaveFX from 'fx/pointer/wave';
import WarpPipelinePlugin from 'phaser3-rex-plugins/plugins/warppipeline-plugin.js';
import ExpandingSpritesBackgroundFx from 'src/fx/background/expanding-sprites';
import { hideBanner } from 'util/ad-util';
import { useModule } from 'src/modules/modules';


class Game extends BaseScene {
    private modules: ReturnType<typeof useModule>;
    private bgActive: boolean = false;
    constructor(){
        super({
            key: TemplateTypes.Scene.GAME,
            trackKey: 'MUSIC_menu',
            transition: {
                scene: {
                    enter: {
                        name: 'fade',
                        duration: 500
                    },
                    exit: {
                        name: 'fade',
                        duration: 500
                    },
                },
                menu: {
                    exit: {
                        name: 'fade-scale',
                        duration: 500
                    },
                    enter: {
                        name: 'fade',
                        duration: 500
                    }
                },
                audio: {
                    exit: {
                        name: 'detune',
                        duration: 500
                    },
                    enter: {
                        name: 'fade',
                        duration: 500
                    }
                }
            }
        });

        this.modules = useModule();
    }

    init(){
        super.init();
        this.input.setTopOnly(false);
        hideBanner();
    }

    async create(){
        this.enter();

        /**
         * Reset game state
         */
        this.bgActive = false;
        this.modules.game.restage(this);
        this.events.on('pause', this.handlePause, this);
        this.events.on('resume', this.handleResume, this);
        this.events.on('shutdown', () => {
            this.events.removeListener('pause', this.handlePause, this);
            this.events.removeListener('resume', this.handleResume, this);
            this.input.removeAllListeners()
        });


        //let particles = new EventHorizonBackgroundFX(this, 'FX_bg_event-horizon');
        // let pointerFX = new PointerWaveFX(this, 'FX_pointer_wave');
        // let pipelineInstance  = (<WarpPipelinePlugin> this.plugins.get('rexWarpPipeline'))
        //     .add(<Phaser.GameObjects.GameObject> <unknown> particles.particles, {
        //         speedEnable: true,
        //         speedY: 2,
        //         frequencyX: 10,
        //         frequencyY: 10,
        //         amplitudeX: 10,
        //         amplitudeY: 10,
        //     });

    }

    handlePause(){

    }

    handleResume(){

    }

    gameOver(){
        //this.modules.global.startScene('PostGame');
    }

    startBackgroundFx(tint?: number){
        if (this.bgActive) return;
            this.bgActive = true;

        const { theme } = useModule();

        let pointerFX = new PointerWaveFX(this, 'FX_pointer_wave_filled');
        new ExpandingSpritesBackgroundFx(this, 'FX_pointer_wave_filled', tint ? [tint] : theme.getSetAsTint('backgroundFX'));

        let pipelineInstance  = (<WarpPipelinePlugin> this.plugins.get('rexWarpPipeline'))
            .add(<Phaser.GameObjects.GameObject> <unknown> this.cameras.main, {
                speedEnable: true,
                speedY: 2,
                frequencyX: 10,
                frequencyY: 10,
                amplitudeX: 10,
                amplitudeY: 10,
            });
    }

    update(time: number, delta: number){
        super.update(time, delta);
    }
}

export default Game;